import { useEffect, useState } from 'react';

let probe: Promise<boolean> | null = null;

/** One request per page load, however many components ask. */
function probeOnce(): Promise<boolean> {
    probe ??= fetch(`${window.location.origin}/.well-known/poppy.json`, { cache: 'no-store' })
        .then((res) => (res.ok ? res.json() : null))
        .then((doc: { protocol_version?: unknown } | null) => !!doc && typeof doc.protocol_version === 'string')
        .catch(() => false);
    return probe;
}

/**
 * Does this server offer the Personal Agent Protocol? True when its discovery document answers —
 * only where MCP_POPPY_ENABLED is on — so the partner guide is linked only where it exists.
 */
export function usePersonalAgents(): boolean {
    const [available, setAvailable] = useState(false);
    useEffect(() => {
        let cancelled = false;
        void probeOnce().then((ok) => {
            if (!cancelled) setAvailable(ok);
        });
        return () => {
            cancelled = true;
        };
    }, []);
    return available;
}
